import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { Badge, Button, Collapse } from "reactstrap";
import KanbanCard from "./KanbanCard";
import { ACCEPTED, isRejected } from "../helpers";

const Column = ({
                  droppableId, title, required, hits, steps,
                  openForm, showRejected, toggleRejected, goToList, waiting,
                  isProcessClosed, canEdit
                }) => {
  const { setNodeRef, isOver } = useDroppable({ id: droppableId });
  const normals = hits.filter(h => !isRejected(h._source));
  const rejects = hits.filter(h => isRejected(h._source));
  const isAccepted = droppableId.endsWith(`-${ACCEPTED.type}`);

  return (
    <div ref={setNodeRef} className="kanban-col me-4"
         style={{ background: isOver ? "#eef" : "#fafafa" }}>
      <h6 className="text-uppercase fw-bold small mb-2">
        {title} {required && <Badge color="warning">req</Badge>}
      </h6>

      {normals.map(h => (
        <KanbanCard
          key={h._id}
          hit={h}
          steps={steps}
          openForm={openForm}
          goToList={goToList}
          waiting={waiting}
          isProcessClosed={isProcessClosed}
          canEdit={canEdit}
        />
      ))}

      {rejects.length > 0 && !isAccepted && (
        <>
          <Button color="link" size="sm" className="p-0 my-1 fw-bold" onClick={toggleRejected}>
            {showRejected ? "▼" : "►"} Descartados ({rejects.length})
          </Button>
          <Collapse isOpen={showRejected}>
            {rejects.map(h => (
              <KanbanCard
                key={h._id}
                hit={h}
                steps={steps}
                openForm={openForm}
                goToList={goToList}
                waiting={waiting}
                isProcessClosed={isProcessClosed}
                canEdit={canEdit}
              />
            ))}
          </Collapse>
        </>
      )}
    </div>
  );
};

export default React.memo(Column);
